import { Box, ListItemButton, Radio, Typography } from '@mui/material';
import { useFormContext } from 'react-hook-form';

export interface AIFileNameSuggestionElementProps {
  name: string;
  onClick: (selectedName: string) => void;
  isLoading?: boolean;
}

export const AIFileNameSuggestionElement = ({
  name,
  onClick,
  isLoading = false,
}: AIFileNameSuggestionElementProps) => {
  const { watch } = useFormContext();
  const currentFileName = watch('newFileName');
  const isSelected = currentFileName === name;

  return (
    <ListItemButton onClick={() => onClick(name)}>
      <Typography
        component="div"
        sx={{
          wordBreak: 'break-word',
          overflowWrap: 'break-word',
          flex: 1,
          color: isLoading ? '#919eab' : 'inherit',
          fontWeight: isSelected ? 600 : 400,
        }}
      >
        {name}
      </Typography>
      <Box>
        <Radio
          checked={isSelected}
          onChange={() => onClick(name)}
          disabled={isLoading}
        />
      </Box>
    </ListItemButton>
  );
};
